import { observer } from 'mobx-react-lite'
import { Box, Typography } from 'shared/ui'

export const BusinessHoursTitle = observer(
  ({ title, description }: { title: string; description: string }) => {
    return (
      <Box display={'flex'} flexDirection={'column'} gap={'4px'} flex={1}>
        <Typography
          ariaLabel='title'
          variant='body-md-medium'
          color='var(--content-primary-primary)'
        >
          {title}
        </Typography>
        <Typography
          ariaLabel='title'
          variant='body-md-regular'
          color='var(--content-primary-tertiary)'
        >
          {description}
        </Typography>
      </Box>
    )
  }
)
